define('apps/admin/views/modals/upload-promo-image',[
        'app',
        'njs!apps/admin/templates/includes/modals/_upload_promo_image(params:tmpl=admin/main/includes/modals/_upload_promo_image.html)',
    ], function(app, template) {
        'use strict';

        return Mn.ItemView.extend({

            "events": {
                "click #cancel-profile-image-submit": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
                "click #edit-profile-image-submit": "uploadImage"
            },

            "template": template,

            "uploadImage": function(e){
                e.preventDefault();

                var url = this.model.get('baseUrl') + '/upload';

                if (this.model.get('hasImage')) {
                    // perform delete before uploading new banner image
                    this.deleteImage();
                }

                var uploadData = new FormData(),
                    fileData = $('#edit-profile-image-file')[0];

                if (fileData && fileData.files) {
                    var file = fileData.files[0];
                    // Add the file to the form data
                    uploadData.append('banner_image', file);
                    uploadData.append('promo_id', this.model.get('promoId'));
                    // Submit to the url that came back
                    $.ajax({
                        "type": "POST",
                        "url": url,
                        "enctype": 'multipart/form-data',
                        "data": uploadData,
                        "headers": {
                            'X-Token': this.model.get('token')
                        },
                        "contentType": false,  // Needed
                        "processData": false,  // Needed
                        "success": _.bind(function(resp) {
                            this.trigger("uploadSuccess", resp);
                        }, this),
                        "error": _.bind(function(err) {
                            this.trigger("uploadError", err);
                        }, this)
                    });
                }
            },

            "deleteImage": function() {
                var bannerId = this.model.get('bannerId');
                var promoId = this.model.get('promoId');
                var url = this.model.get('baseUrl') + '/remove/' + bannerId + '?promo_id=' + promoId;

                $.ajax({
                    "type": "DELETE",
                    "url": url,
                    "success": _.bind(function(resp) {
                        this.trigger("deleteSuccess", resp);
                    }, this),
                    "error": _.bind(function(err) {
                        this.trigger("deleteError", err);
                    }, this)
                });
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });

});

